import React, { useEffect, useState } from "react";
import siteConfig from "../data/siteConfig.json";
import FacebookButton from "./FacebookButton";
import data from "../data/imageData.json";
import "./styles/Footer.css";
import { Link } from "react-router-dom";



const Footer = () => {
  const [year, setYear] = useState(siteConfig.buildYear);
  useEffect(() => setYear(new Date().getFullYear()), []);
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <img
            src={data.serconsLogo.url}
            alt="Sercons & Contractor"
            width="717" height="392" loading="lazy" decoding="async"
            style={{ width: "150px", height: "auto" }}
          />
        </div>
        <div className="footer-contact">
          <h3>Contact</h3>
          <p>
            Email:{" "}
            <a href="mailto:serconscontractor@gmail.com">
              serconscontractor@gmail.com
            </a>
          </p>
          <p>Adresă: Str. 14 Noiembrie, 5B, Tulcea, Romania</p>
        </div>
        <div className="footer-links">
          <h3>Navigare</h3>
          <ul>
            <li>
              <Link to="/">Acasă</Link>
            </li>
            <li>
              <Link to="/portfolio">Portofoliu</Link>
            </li>
            <li>
              <Link to="/desprenoi">Despre Noi</Link>
            </li>
            <li>
              <Link to="/#services">Servicii</Link>
            </li>
          </ul>
        </div>
        <div className="footer-social">
          <h3>Urmăriți-ne</h3>
          <FacebookButton />
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {year} Sercons&Contractor</p>
      </div>
    </footer>
  );
};

export default Footer;
